import { render } from "./HeaderMenuButton.vue?vue&type=template&id=4b1e8fd0"
import script from "./HeaderMenuButton.vue?vue&type=script&lang=js"
export * from "./HeaderMenuButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__